import { getBranch } from "~/helpers/branch";

export default defineNuxtPlugin({
  name: 'branch',
  setup() {
    return {
      provide: {
        branch: getBranch()
      }
    };
  }
});